module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/bonus-pict-202b703e7dcd32d21ab43e0a5400d3bf.jpg";